import {applyMiddleware, compose, createStore} from 'redux'
import thunk from 'redux-thunk'
import {createHashHistory} from 'history';
import {routerMiddleware} from 'connected-react-router'

import combinedReducer from './modules/reducers'

const history = createHashHistory()
const router = routerMiddleware(history)
const enhancers = [applyMiddleware(thunk, router)]

const {__REDUX_DEVTOOLS_EXTENSION_COMPOSE__} = window

let composeEnhancers = compose

if (
    process.env.NODE_ENV !== 'production' &&
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) {
    composeEnhancers = __REDUX_DEVTOOLS_EXTENSION_COMPOSE__
}

const store = (initialState) => createStore(
    combinedReducer(history),
    initialState,
    composeEnhancers(...enhancers)
)

export default store
